//
// Tooltips
//
// Example Markup (HAML)
//
//   %span.tooltip{title: 'My tooltip content'}
//
import Tippy from 'tippy.js'

document.addEventListener('turbolinks:load', () => {
  new Tippy('.tooltip', {
    placement: 'left-end',
    theme:     'afc',
    maxWidth: 250
  })
})
